import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { TableCell, TableRow } from '@mui/material';

import { SortLabel } from 'components/SortLabel';

import { TableHeadWrapper } from './styles';

export interface ISortData {
    label: string;
    sortType: string;
    orderBy: string;
    id: string | null;
}

export interface IHeadCell {
    id: string;
    label: string;
    sortable?: boolean;
    sortData?: ISortData[];
    width?: number | string;
}

interface ITableHeadProps {
    columns: IHeadCell[];
    onRequestSort?: any;
    total?: number | null;
}

export const TableHead = (props: ITableHeadProps) => {
    const { onRequestSort, columns, total = 1 } = props;
    const [searchParams] = useSearchParams();
    const currentParams = Object.fromEntries([...searchParams]);
    const sortables: ISortData[] = [];

    for (let i = 0; i < columns.length; i++) {
        // eslint-disable-next-line no-prototype-builtins
        if (!columns[i].hasOwnProperty('sortable')) {
            continue;
        }
        columns[i]?.sortData?.map(el => {
            sortables.push(el);
        });
    }

    const sortableObj: ISortData | undefined = sortables.find(
        sortable => sortable.orderBy === currentParams.orderBy && sortable.sortType === currentParams.sortType,
    );

    const [sort, setSort] = useState<{
        orderBy: string;
        sortType: string;
        id: string | null;
    } | null>({
        orderBy: currentParams.orderBy,
        sortType: currentParams.sortType,
        id: sortableObj ? sortableObj.id : null,
    });

    const handleChange = ({ sortType, orderBy, id }: { sortType: string; orderBy: string; id: string | null }) => {
        if (sort && sort.sortType === sortType && sort.orderBy === orderBy) {
            setSort(null);
        } else {
            setSort({
                sortType,
                orderBy,
                id,
            });
        }
    };
    useEffect(() => {
        if (onRequestSort) {
            onRequestSort(sort);
        }
    }, [sort]);

    return (
        <TableHeadWrapper>
            <TableRow>
                {columns.map(({ id, label, sortable, sortData, width }: IHeadCell) => {
                    return (
                        <TableCell key={id} style={{ width: width ? `${width}px` : 'auto' }}>
                            {sortable ? (
                                <SortLabel total={total} label={label} sort={sort} handleChange={handleChange} id={id} data={sortData} />
                            ) : (
                                label
                            )}
                        </TableCell>
                    );
                })}
            </TableRow>
        </TableHeadWrapper>
    );
};
